// extracted by mini-css-extract-plugin
module.exports = {"brand":"Brand_brand__1cq-h","logo":"Brand_logo__1Dqlj","title":"Brand_title__2PoRo"};